if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
        this.savedSizeChartHTML = null;
        this.pageHasSizeChart = false;
        this.cachePageSizeChartIfPresent();
        
        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      cachePageSizeChartIfPresent() {
        const originSizeChartModal = document.querySelector('.size_chart-popup-modal .size-chart-img');
        if (!originSizeChartModal || !originSizeChartModal.innerHTML.trim()) return false;

        this.pageHasSizeChart = true;
        if (this.savedSizeChartHTML === null) {
          this.savedSizeChartHTML = originSizeChartModal.innerHTML;
        }
        return true;
      }

      restorePageSizeChartHTML() {
        if (!this.pageHasSizeChart) return;

        const originSizeChartModal = document.querySelector('.size_chart-popup-modal .size-chart-img');
        if (originSizeChartModal && this.savedSizeChartHTML !== null) {
          HTMLUpdateUtility.setInnerHTML(originSizeChartModal, this.savedSizeChartHTML);
        }
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        if (this.pageHasSizeChart) this.restorePageSizeChartHTML();
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            responseHTML?.querySelector('.product__media-item.is-active .magnifier-open[data-fancybox]')?.setAttribute('tabindex', '0'); // Custom Code: Update tabindex to the active fancybox in the product info

            // Custom Code: Update product add on id in quick add popup modal
            let productAddOn = responseHTML.querySelector('product-add-on');
            if(productAddOn) {
              let addOnInputList = productAddOn.querySelectorAll('input');
              let addOnLabelList = productAddOn.querySelectorAll('label');
              addOnInputList?.forEach((item) => {
                let oldId = item.getAttribute('id');
                let oldName = item.getAttribute('name');
                let newId = `quickadd-${oldId}`;
                let newName = `quickadd-${oldName}`;
                item.setAttribute('id', newId);
                item.setAttribute('name', newName);
              });
              addOnLabelList?.forEach((item) => {
                let oldFor = item.getAttribute('for');
                let newFor = `quickadd-${oldFor}`;
                item.setAttribute('for', newFor);
              });
            }

            // Custom Code: Update size chart info of every different product
            let newSizeChartModal = responseHTML?.querySelector('.size_chart-popup-modal .size-chart-img');
            let originSizeChartModal = document.querySelector('.size_chart-popup-modal .size-chart-img');
            if(newSizeChartModal && originSizeChartModal) {
              HTMLUpdateUtility.setInnerHTML(originSizeChartModal, newSizeChartModal.innerHTML);
            }
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);

            // Custom Code: reset swatch label width and height 
            this.querySelectorAll(`.swatch-container:not(.color-swatch) .swatch-label`)?.forEach((innerLabel) => {innerLabel.style.width = `auto`;innerLabel.style.height = `auto`});
            setTimeout(()=> {this.initSwatchWidth();}, 100);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      // Custom event: set swatch(not color swatch) common width
      initSwatchWidth() {
        if(this.querySelectorAll(`.swatch-container:not(.color-swatch)`).length > 0){
          this.querySelectorAll(`.swatch-container:not(.color-swatch)`)?.forEach((el) => {
            let width = 0;
            let height = 0;
            if(el.querySelectorAll(`.swatch-label`).length > 1){
              el.querySelectorAll(`.swatch-label`).forEach((innerEl) => {
                if(width < innerEl.getBoundingClientRect().width){width = innerEl.getBoundingClientRect().width;}
                if(height < innerEl.getBoundingClientRect().height){height = innerEl.getBoundingClientRect().height;}
              });
              let maxW = Math.ceil(width + 2);
              let maxH = Math.ceil(height + 2);
              el.querySelectorAll(`.swatch-label`).forEach(innerEl => {innerEl.style.width = `${maxW}px`;innerEl.style.height = `${maxH}px`});
            }
          });
        }
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}